import OceanTrackingMap from '../../pages/tracking/ocean/TrackingMap';
import OceanTracking from '../../pages/tracking/ocean/OceanTracking';
import { useParams } from 'react-router-dom';
import React from 'react';

const TrackingRenderer = () => {
    const { id } = useParams();
    let trackingComponent;
    
    switch (id) {
      case 'Ocean Tracking (Deprecated)':
        trackingComponent = <OceanTrackingMap />;
        break;
      case 'Ocean Tracking':
        trackingComponent = <OceanTracking/>;
        break;
      default:
        trackingComponent = <div>Tracking report not found</div>;
    }

  return (
    <div>
      {trackingComponent}
    </div>
  );
}

export default TrackingRenderer